import { render } from "./zendesk.vue?vue&type=template&id=1f627edf&scoped=true"
import script from "./zendesk.vue?vue&type=script&lang=js"
export * from "./zendesk.vue?vue&type=script&lang=js"

import "./zendesk.vue?vue&type=style&index=0&id=1f627edf&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f627edf"]])

export default __exports__